var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"Pesquisa","placeholder":"Pesquisar schema","outlined":"","dense":""},on:{"input":function($event){return _vm.$emit('search', _vm.search)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }